import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export function uniqBy(key, items) {
  return _toConsumableArray(new Map(items.map(function (item) {
    return [item[key], item];
  })).values());
}